import React from 'react';

export type University = {
  id: number;
  name: string;
  url: string;
};

export type Department = {
  id: number;
  name: string;
  university: University;
  url: string;
};

export type Interest = {
  id: number;
  name: string;
  url: string;
};

export type User = {
  id: number;
  department: Department;
  displayName: string;
  domainName: string;
  email: string;
  firstName: string;
  lastName: string;
  middleInitials: string;
  followeeIds: number[];
  hasPhoto: boolean;
  interests: Interest[];
  pageName: string;
  photo: string;
  position: string;
  positionId: number;
  url: string;
};

export enum SortOption {
  CreatedAt = 'created_at',
  FirstName = 'first_name',
  LastName = 'last_name',
}

export type NetworkContextState = {
  viewerFolloweeIds: Set<number>;
  follow: (userId: number, clientOnly?: boolean) => void;
  unfollow: (userId: number, clientOnly?: boolean) => void;
  block: (userId: number) => void;
  enableContacts: boolean;
  enableFacebook: boolean;
  isGoogleConnected: boolean;
  setIsGoogleConnected: (isConnected: boolean) => void;
  googleAccountEmail: string;
  setGoogleAccountEmail: (email: string) => void;
  isFacebookConnected: boolean;
  setIsFacebookConnected: (isConnected: boolean) => void;
  facebookAccountName: string;
  setFacebookAccountName: (name: string) => void;
  isFacebookAutoFollow: boolean;
  setIsFacebookAutoFollow: (isAutoFollow: boolean) => void;
};

export const NetworkContext = React.createContext<NetworkContextState>({
  viewerFolloweeIds: new Set(),
  follow: () => null,
  unfollow: () => null,
  block: () => null,
  enableContacts: false,
  enableFacebook: false,
  isGoogleConnected: false,
  setIsGoogleConnected: () => null,
  googleAccountEmail: '',
  setGoogleAccountEmail: () => null,
  isFacebookConnected: false,
  setIsFacebookConnected: () => null,
  facebookAccountName: '',
  setFacebookAccountName: () => null,
  isFacebookAutoFollow: false,
  setIsFacebookAutoFollow: () => null,
});
